import { hasFlag } from 'country-flag-icons';
import getUnicodeFlagIcon from 'country-flag-icons/unicode';
import { getNormalizedLanguageCode } from './localization';

const LANGUAGE_TO_COUNTRY_CODE: Record<string, string> = {
  en: 'GB',
  ka: 'GE',
  ru: 'RU',
};

export function getFlagCountryCodeForLanguage(languageCode: string): string | null {
  const normalized = getNormalizedLanguageCode(languageCode).replace('_', '-');
  const [primary, region] = normalized.split('-');
  const primaryLanguage = primary ?? normalized;

  if (region) {
    const regionCode = region.toUpperCase();
    if (hasFlag(regionCode)) {
      return regionCode;
    }
  }

  const mappedCountryCode = LANGUAGE_TO_COUNTRY_CODE[primaryLanguage] ?? primaryLanguage.toUpperCase();
  return hasFlag(mappedCountryCode) ? mappedCountryCode : null;
}

export function getFlagIconForLanguage(languageCode: string): string {
  const countryCode = getFlagCountryCodeForLanguage(languageCode);
  return countryCode ? getUnicodeFlagIcon(countryCode) : '🏳';
}
